/* eslint-disable max-len */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Inject, Prop } from 'vue-property-decorator';
import { INJECT_UICORE_BUS, INJECT_UICORE_COMPONENT_HOST, INJECT_UICORE_RENDERER } from "../../../lib/utils/consts";
import { escapeSlotName } from "../../../lib/utils/layout";
import { getBaseLayout } from "../../../lib/designer/utils/layout";
import { isEqual } from "lodash-es";
let UcScopedSlot = class UcScopedSlot extends Vue {
  constructor() {
    super(...arguments);
    this.internalDefaultObject = null;
    this.rendererRev = 0; // Vue 响应式的问题。Vue2 没有 shallowRef
  }
  created() {
    const {
      host
    } = this;
    const removeIfMatch = name => {
      var _host$ucScopedSlotIns;
      const set = (_host$ucScopedSlotIns = host.ucScopedSlotInstances) === null || _host$ucScopedSlotIns === void 0 ? void 0 : _host$ucScopedSlotIns[name];
      if (!set) return;
      set.delete(this);
      if (!set.size) delete host.ucScopedSlotInstances[name];
    };
    this.$watch(() => this.name, (n, o) => {
      const instances = host.ucScopedSlotInstances || (host.ucScopedSlotInstances = {});
      const set = instances[n] || (instances[n] = new Set());
      set.add(this);
      if (o) removeIfMatch(o);
    }, {
      immediate: true
    });
    this.$once('hook:beforeDestroy', () => removeIfMatch(this.name));
    // 由于 $slots 在 Vue2 不是响应式的，所以需要脏一下
    // 监听 renderer 的 ucPagelet
    this.$watch(() => {
      var _this$host$$vnode$dat, _vs$scopedSlots;
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      this.hostRenderer.ucVNodeFactory; // add dep
      const vs = (_this$host$$vnode$dat = this.host.$vnode.data) === null || _this$host$$vnode$dat === void 0 ? void 0 : _this$host$$vnode$dat['uc:VNodeState'];
      if (!vs) return null;
      return ((_vs$scopedSlots = vs.scopedSlots) === null || _vs$scopedSlots === void 0 ? void 0 : _vs$scopedSlots[this.name]) || vs.generateVueRenderFunctionForScopedSlot(this.slotMeta) || null;
    }, renderFn => {
      this.slotRenderFn = renderFn;
      this.$forceUpdate();
    }, {
      immediate: true
    });
    this.$watch(() => this.default, val => {
      if (!isEqual(val, this.internalDefaultObject)) {
        this.internalDefaultObject = this.default;
      }
    }, {
      immediate: true
    });
    this.$on('hook:mounted', this._syncRenderer);
    this.$on('hook:updated', this._syncRenderer);
  }
  /** 和 props 里的 "default" 不同，这个肯定有值 */
  get internalDefault() {
    return this.internalDefaultObject || Object.freeze({
      layout: getBaseLayout(this.uc, 'scopedSlotRoot')
    });
  }
  get slotMeta() {
    return {
      id: escapeSlotName(this.name),
      type: 'scoped',
      getSlotContainerElement: () => this.$el,
      ucScopedSlot: this,
      frozen: this.isFrozen,
      default: this.internalDefault
    };
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  _syncRenderer() {
    var _this$lastVNode;
    const inst = ((_this$lastVNode = this.lastVNode) === null || _this$lastVNode === void 0 ? void 0 : _this$lastVNode.componentInstance) || null;
    if (inst !== this._renderer) {
      this._renderer = inst;
      this.rendererRev += 1;
    }
  }
  /** 渲染出来的子页面片 */
  get renderer() {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.rendererRev; // Vue Dep
    return this._renderer;
  }
  render(h) {
    const f = this.slotRenderFn;
    const vnode = f ? f(this.$attrs) : h();
    this.lastVNode = vnode;
    return vnode;
  }
};
__decorate([Prop({
  type: String,
  required: true
})], UcScopedSlot.prototype, "name", void 0);
__decorate([Prop({
  type: Object,
  default: null
})], UcScopedSlot.prototype, "default", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], UcScopedSlot.prototype, "isFrozen", void 0);
__decorate([Inject({
  from: INJECT_UICORE_COMPONENT_HOST
})], UcScopedSlot.prototype, "host", void 0);
__decorate([Inject({
  from: INJECT_UICORE_RENDERER
})], UcScopedSlot.prototype, "hostRenderer", void 0);
__decorate([Inject({
  from: INJECT_UICORE_BUS
})], UcScopedSlot.prototype, "uc", void 0);
UcScopedSlot = __decorate([Component({
  name: 'UcScopedSlot',
  ucIsPatchedComponent: true,
  inheritAttrs: false
})], UcScopedSlot);
export { UcScopedSlot };
//# sourceMappingURL=UcScopedSlot.js.map
